import crud from "./crud";

const path = "alarms/alarm_count";
const struct = {
  pk: 1,
  alarm_count: "",
  producer_id: null,
  alarm_code_id: null,
};
const generic = crud(path, struct);

const state = {
  ...generic.state,
};

const getters = {
  ...generic.getters,
};

const mutations = {
  ...generic.mutations,
};

const actions = {
  ...generic.actions,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
